import script from "./rainOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./rainOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./rainOverlay.vue?vue&type=style&index=0&id=60cb77ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60cb77ca"]])

export default __exports__